/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Ctrl_Big1_AltInputs */

const en_mk_ctrl_big1_alt = /** @type {(inputs: Mk_Ctrl_Big1_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep Cost & duration page: summary tiles, per-feature table, daily and per-agent charts`)
};

const id_mk_ctrl_big1_alt = /** @type {(inputs: Mk_Ctrl_Big1_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman Biaya & durasi Bystep: tile ringkasan, tabel per fitur, grafik harian dan per agent`)
};

/**
* | output |
* | --- |
* | "Bystep Cost & duration page: summary tiles, per-feature table, daily and per-agent charts" |
*
* @param {Mk_Ctrl_Big1_AltInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_ctrl_big1_alt = /** @type {((inputs?: Mk_Ctrl_Big1_AltInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Ctrl_Big1_AltInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_ctrl_big1_alt(inputs)
	return en_mk_ctrl_big1_alt(inputs)
});